<template>
  <div class="vip-guarantee-fee">
    <div class="guarantee-title">
      <img
        src="@/assets/images/personal-center/vip-home/vip-guarantee-fee-title-icon.png"
        alt=""
      />
      <span class="title-text">保证金担保</span>
    </div>
    <div class="content-wrapper">
      <div class="content">
        <div class="can-use info">
          <div class="info-label">当前可用额度(元)</div>
          <div class="info-value">{{ canUseAmount }}</div>
        </div>
        <el-divider direction="vertical" />
        <div class="total info">
          <div class="info-label">总额度(元)</div>
          <div class="info-value">{{ totalAmount }}</div>
        </div>
      </div>
      <div class="vip-button" @click="openHistory">查看使用记录</div>
    </div>

    <a-modal
      v-model="historyVisible"
      title="使用记录"
      :footer="null"
      :mask-closable="false"
      width="900px"
    >
      <jczh-table-content
        :data="historyList"
        :option="historyListOption"
        pagination
        :page.sync="historyPage"
        :limit.sync="historySize"
        :total="historyTotal"
        border
      />
    </a-modal>
  </div>
</template>

<script>
// 接口
import {
  getVipGuaranteeApi,
  getVipGuaranteeHistoryApi
} from '@/api/financial/guarantee'
import { mapState } from 'vuex'

/**
 * @description 会员保证金折抵显示组件，在会员主页使用
 */
export default {
  name: 'VipGuaranteeFee',

  data() {
    return {
      canUseAmount: 0,
      totalAmount: 0,

      historyVisible: false,
      historyList: [],
      historyPage: 1,
      historySize: 10,
      historyTotal: 0,
      historyListOption: [
        { label: '使用单位', prop: 'companyName' },
        { label: '使用时间', prop: 'useTime' },
        { label: '项目名称', prop: 'projectName' },
        { label: '项目编号', prop: 'projectCode' },
        { label: '交易流水号', prop: 'tradeCode' },
        { label: '使用额度（元）', prop: 'useQuota' }
      ]
    }
  },

  computed: {
    ...mapState('user', ['vipInfo'])
  },

  watch: {
    vipInfo: {
      handler(val) {
        if (val.productInfo?.productCode) {
          this.getVipGuaranteeFeeInfo()
        }
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    getVipGuaranteeFeeInfo() {
      getVipGuaranteeApi({ productCode: this.vipInfo.productInfo.productCode })
        .then(({ data }) => {
          this.totalAmount = data.totalQuota || 0
          this.canUseAmount = data.remainQuota || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    openHistory() {
      this.historyVisible = true
      this.getVipGuaranteeUseHistory()
    },

    getVipGuaranteeUseHistory() {
      const params = {
        page: this.historyPage,
        size: this.historySize
      }
      getVipGuaranteeHistoryApi(params)
        .then(({ data }) => {
          this.historyList = data.records || []
          this.historyTotal = data.total || 0
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.vip-guarantee-fee {
  background: url('~@/assets/images/personal-center/vip-home/vip-guarantee-fee-background.png')
    100% no-repeat;
  background-size: cover;
  border-radius: 4px;

  display: flex;
  align-items: center;
  padding: 6px 16px 6px 14px;

  .guarantee-title {
    img {
      width: 38px;
      height: 36px;
    }

    .title-text {
      color: $member-second-color;
      font-size: 16px;
      @include text-bold;
      margin-left: 6px;
    }
  }

  .content-wrapper {
    flex: 1;
    margin-left: 24px;
    background: linear-gradient(90deg, #fffaf0 0%, #fff2f3 100%);
    border-radius: 4px;
    padding: 6px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .content {
      display: flex;
      align-items: center;

      .info {
        display: flex;
        align-items: center;

        .info-label {
          color: $text-second-color;
          font-size: 12px;
          margin-right: 10px;
        }

        .info-value {
          @include text-bold;
        }

        &.can-use {
          .info-value {
            font-size: 20px;
            color: $danger-color;
          }
        }

        &.total {
          .info-value {
            font-size: 16px;
            color: $member-second-color;
          }
        }
      }

      ::v-deep .el-divider--vertical {
        margin: 0 20px;
      }
    }

    .vip-button {
      padding: 6px 12px;
      border-radius: 4px;
      background-color: $member-sixth-color;
      color: $member-second-color;
      text-align: center;
      cursor: pointer;
      font-size: 12px;
    }
  }
}
</style>
